import { render, staticRenderFns } from "./AlternativeSelect.vue?vue&type=template&id=35484fcb&scoped=true"
import script from "./AlternativeSelect.vue?vue&type=script&lang=js"
export * from "./AlternativeSelect.vue?vue&type=script&lang=js"
import style0 from "./AlternativeSelect.vue?vue&type=style&index=0&id=35484fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35484fcb",
  null
  
)

export default component.exports